import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timezoneAdjust',
  standalone: true,
})
export class TimezoneAdjustPipe implements PipeTransform {
  transform(value: string | null | undefined, hoursToAdd: number = 2): string {
    if (!value) {
      return '';
    }

    try {
      // Parse the input date
      const date = new Date(value);

      // Add the specified number of hours
      date.setHours(date.getHours() + hoursToAdd);

      // Return the adjusted date as ISO string
      return date.toISOString();
    } catch (error) {
      console.error('Error adjusting timezone:', error);
      return value;
    }
  }
}
